"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeConversion = void 0;

function timeConversion(duration) {
  var portions = [];
  var msInHour = 1000 * 60 * 60;
  var hours = Math.trunc(duration / msInHour);

  if (hours > 0) {
    portions.push(hours + 'h');
    duration = duration - hours * msInHour;
  }

  var msInMinute = 1000 * 60;
  var minutes = Math.trunc(duration / msInMinute);

  if (minutes > 0) {
    portions.push(minutes + 'm');
    duration = duration - minutes * msInMinute;
  }

  var seconds = Math.trunc(duration / 1000);

  if (seconds > 0) {
    portions.push(seconds + 's');
  }

  return portions.join(' ');
}

exports.timeConversion = timeConversion;